import { render, staticRenderFns } from "./OptionsListColumn.vue?vue&type=template&id=cc671dd0&scoped=true"
import script from "./OptionsListColumn.vue?vue&type=script&lang=js"
export * from "./OptionsListColumn.vue?vue&type=script&lang=js"
import style0 from "./OptionsListColumn.vue?vue&type=style&index=0&id=cc671dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc671dd0",
  null
  
)

export default component.exports